"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styles = __importStar(require("./Select.module.css"));
var Select = (function (_super) {
    __extends(Select, _super);
    function Select(props) {
        return _super.call(this, props) || this;
    }
    Select.prototype.render = function () {
        var _a = this.props, json_data = _a.json_data, id = _a.id, onChange = _a.onChange, options = _a.options, classNameWrap = _a.classNameWrap, className = _a.className, _b = _a.errors, errors = _b === void 0 ? {} : _b;
        var value = json_data[id] || "";
        var error = errors[id];
        var css = styles.root;
        if (error) {
            css = css + " " + styles.rootError;
        }
        return (React.createElement("div", { className: classNameWrap },
            React.createElement("select", { id: id, className: css + " " + className + " selectpicker form-control", "data-style": "btn-default", value: value, onChange: function (event) {
                    event.preventDefault();
                    onChange(id, event.target.value);
                } },
                React.createElement("option", { value: "" }, "-- select --"),
                options &&
                    options.map(function (item) {
                        return (React.createElement("option", { key: item.value, value: item.value }, item.name));
                    })),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    return Select;
}(React.Component));
exports.Select = Select;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2VsZWN0LmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvY29tcG9uZW50cy9TZWxlY3QvU2VsZWN0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBRTlCLDBEQUE2QztBQWE3QztJQUE0QiwwQkFBZ0M7SUFDeEQsZ0JBQVksS0FBSztlQUNiLGtCQUFNLEtBQUssQ0FBQztJQUNoQixDQUFDO0lBQ00sdUJBQU0sR0FBYjtRQUNVLElBQUEsZUFBc0YsRUFBckYsd0JBQVMsRUFBRSxVQUFFLEVBQUUsc0JBQVEsRUFBRSxvQkFBTyxFQUFFLGdDQUFhLEVBQUUsd0JBQVMsRUFBRSxjQUFXLEVBQVgsZ0NBQXlCLENBQUE7UUFDNUYsSUFBSSxLQUFLLEdBQUcsU0FBUyxDQUFDLEVBQUUsQ0FBQyxJQUFJLEVBQUUsQ0FBQTtRQUMvQixJQUFNLEtBQUssR0FBRyxNQUFNLENBQUMsRUFBRSxDQUFDLENBQUE7UUFFeEIsSUFBSSxHQUFHLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBQTtRQUNyQixJQUFJLEtBQUssRUFBRTtZQUNQLEdBQUcsR0FBTSxHQUFHLFNBQUksTUFBTSxDQUFDLFNBQVcsQ0FBQTtTQUNyQztRQUVELE9BQU8sQ0FDSCw2QkFBSyxTQUFTLEVBQUUsYUFBYTtZQUN6QixnQ0FDSSxFQUFFLEVBQUUsRUFBRSxFQUNOLFNBQVMsRUFBSyxHQUFHLFNBQUksU0FBUywrQkFBNEIsZ0JBQy9DLGFBQWEsRUFDeEIsS0FBSyxFQUFFLEtBQUssRUFDWixRQUFRLEVBQUUsVUFBQyxLQUFLO29CQUNaLEtBQUssQ0FBQyxjQUFjLEVBQUUsQ0FBQTtvQkFDdEIsUUFBUSxDQUFDLEVBQUUsRUFBRSxLQUFLLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFBO2dCQUNwQyxDQUFDO2dCQUNELGdDQUFRLEtBQUssRUFBQyxFQUFFLG1CQUFzQjtnQkFDckMsT0FBTztvQkFDSixPQUFPLENBQUMsR0FBRyxDQUFDLFVBQUMsSUFBb0I7d0JBQzdCLE9BQU8sQ0FDSCxnQ0FBUSxHQUFHLEVBQUUsSUFBSSxDQUFDLEtBQUssRUFBRSxLQUFLLEVBQUUsSUFBSSxDQUFDLEtBQUssSUFDckMsSUFBSSxDQUFDLElBQUksQ0FDTCxDQUNaLENBQUE7b0JBQ0wsQ0FBQyxDQUFDLENBQ0Q7WUFDUixLQUFLLElBQUksMkJBQUcsU0FBUyxFQUFFLE1BQU0sQ0FBQyxLQUFLO2dCQUFHLEtBQUs7b0JBQU0sQ0FDaEQsQ0FDVCxDQUFBO0lBQ0wsQ0FBQztJQUNMLGFBQUM7QUFBRCxDQUFDLEFBdkNELENBQTRCLEtBQUssQ0FBQyxTQUFTLEdBdUMxQztBQXZDWSx3QkFBTSJ9